import { useState } from "react";
import { Link } from "react-router-dom";
import { Code2, Info, BookOpen, Crown, Mail } from "lucide-react";
import ContactModal from "./ContactModal";

export default function Footer() {
  const [showContactModal, setShowContactModal] = useState(false);
  const year = new Date().getFullYear();

  const links = [
    { to: "/about", label: "About", icon: Info, testid: "footer-about" },
    { to: "/instructions", label: "Instructions", icon: BookOpen, testid: "footer-instructions" },
    { to: "/subscription", label: "Plans", icon: Crown, testid: "footer-plans" },
  ];

  return (
    <footer className="border-t border-border/60 bg-muted/30 mt-auto" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          {/* Brand */}
          <Link to="/" className="flex items-center gap-2 group w-fit" data-testid="footer-logo">
            <div className="p-1.5 rounded-lg bg-primary/10 group-hover:bg-primary/20 transition-colors">
              <Code2 className="w-5 h-5 text-primary" />
            </div>
            <span className="font-heading font-bold text-base">
              <span className="text-primary">CodingDrills</span>
              <span className="text-foreground">.au</span>
            </span>
          </Link>

          {/* Links */}
          <nav className="flex flex-wrap items-center gap-x-6 gap-y-3">
            {links.map(({ to, label, icon: Icon, testid }) => (
              <Link
                key={to}
                to={to}
                className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors"
                data-testid={testid}
              >
                <Icon className="w-4 h-4" />
                {label}
              </Link>
            ))}
            <button
              onClick={() => setShowContactModal(true)}
              className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors"
              data-testid="footer-contact"
            >
              <Mail className="w-4 h-4" />
              Contact
            </button>
          </nav>
        </div>

        {/* Bottom bar */}
        <div className="mt-6 pt-6 border-t border-border/40 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-xs text-muted-foreground">
          <p>© {year} CodingDrills.au. All rights reserved.</p>
          <p>
            Part of the{" "}
            <a
              href="https://www.creatoracademy.edu.au"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:underline"
            >
              Creator Academy
            </a>{" "}
            CodePlay™ system.
          </p>
        </div>
      </div>

      <ContactModal isOpen={showContactModal} onClose={() => setShowContactModal(false)} />
    </footer>
  );
}
